import Vue from "vue";
import Vuex from "vuex";
import { area } from "./modules/area/";
import { canvas } from "./modules/canvas/";
import { concert } from "./modules/concert/";
import { config } from "./modules/config/";
import { common } from "./modules/common/";
import { device } from "./modules/device/";
import { env } from "./modules/env/";
import { geo } from "./modules/geo/";
import { mode } from "./modules/mode/";
import { history } from "./modules/history/";
import { loader } from "./modules/loader/";
import { lock } from "./modules/lock/";
import { tablet } from "./modules/tablet/";
import { tool } from "./modules/tool/";
import { touch } from "./modules/touch/";
import { tutorial } from "./modules/tutorial/";
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    area: area,
    canvas: canvas,
    concert: concert,
    config: config,
    common: common,
    device: device,
    env: env,
    geo: geo,
    history: history,
    loader: loader,
    lock: lock,
    mode: mode,
    tablet: tablet,
    tool: tool,
    touch: touch,
    tutorial: tutorial
  }
});
